import type {
  ActivatedResource,
  AmActivatedResource,
  MagActivatedResource,
} from '@/features/activation/types/activatedResource'
import type { Activation, AmActivation, MagActivation } from '@/features/activation/types/activation'
import { ActivationType } from '@/features/activation/types/activation'
import type { MarketProgramType } from '@/types/marketProgramType'

export function convertMagActivationToStandard(activation: MagActivation, marketProgram?: MarketProgramType) {
  return {
    id: activation.id,
    startedAt: activation.startedAt,
    endedAt: activation.endedAt,
    marketProgram: marketProgram,
    type: ActivationType.DISTURBANCE,
  } as Activation
}

export function convertAmActivationToStandard(activation: AmActivation) {
  return {
    ...activation,
    marketProgram: activation.marketProgram?.toLowerCase().replaceAll('_', '-'),
    activatedResources: activation.activatedResources,
  } as Activation
}

export function convertPresentActivationToStandard(
  magActivation: MagActivation | null,
  amActivation: AmActivation | null,
  marketPrograms: Map<number | undefined, MarketProgramType | undefined>,
): Activation | undefined {
  if (magActivation) return convertMagActivationToStandard(magActivation, marketPrograms.get(magActivation?.serviceId))
  if (amActivation) return convertAmActivationToStandard(amActivation)
  return undefined
}

export function convertMagActivatedResourcesToStandard(magActivatedResources: MagActivatedResource[]) {
  return magActivatedResources.map(
    (resource) =>
      ({
        resourceId: resource.id,
        resourceName: resource.wireName,
        sectionName: resource.wireSectionName,
        activatedAt: resource.activatedAt,
        deactivatedAt: resource.deactivatedAt,
      }) as ActivatedResource,
  )
}

export function convertAmActivatedResourcesToStandard(amActivatedResources: AmActivatedResource[]) {
  return amActivatedResources?.map(
    (resource) =>
      ({
        resourceId: resource.resourceId,
        resourceName: resource.resourceName,
        activatedAt: resource.activatedAt,
        deactivatedAt: resource.deactivatedAt,
      }) as ActivatedResource,
  )
}
